<style scoped>
/* Styles copied from your example */
::-webkit-scrollbar {
    width: 10px;
}
::-webkit-scrollbar-thumb {
    background: rgba(191, 188, 188, 0.6);
}
.required_err {
    color: rgba(255, 0, 0);
}
.br {
    color: rgba(109, 103, 164);
}
.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}
.action-btn-spacing {
    margin-left: 8px;
}
.v-progress-linear {
    height: 2px !important;
}
/* Add specific styles if needed */
.protocol-select {
    max-width: 200px; /* Adjust as needed */
}
.events-select {
     max-width: 300px; /* Adjust as needed */
}
.settings-card {
    margin-bottom: 1.5rem; /* Add spacing below settings card */
}
.filter-details {
    margin-top: 8px;
    padding-left: 16px; /* Indent filter details */
}
.status-chip {
    font-weight: bold;
}

.form_select_field {
    margin-top: 30px;
}
.form_text_field {
    margin-top: 10px;
}

</style>

<template>
<div class="nel-management">

    <v-card class="elevation-1 settings-card">
        <v-card-title><h2 class="br">NEL</h2></v-card-title>
        <v-card-text>
            <v-alert v-if="fetch_error" type="error" text>
                {{ fetch_error }}
            </v-alert>
            <v-row v-else-if="!loading_data && nel_enabled !== null">
                <v-col cols="12" md="4">
                    <strong>NEL Enabled:</strong>
                    <v-chip
                        :color="nel_enabled ? 'success' : 'error'"
                        class="ml-2 status-chip"
                        label
                        small
                    >
                        {{ nel_enabled ? 'Yes' : 'No' }}
                    </v-chip>
                </v-col>

                <v-col cols="12" md="8">
                    <strong>Export Filters:</strong>
                    <div class="filter-details">

                        <div>
                            <strong>Source:</strong>
                            <v-chip
                                :color="export_filters.source.enabled ? 'success' : 'grey'"
                                class="ml-2"
                                label
                                small
                            >
                                {{ export_filters.source.enabled ? 'Enabled' : 'Disabled' }}
                            </v-chip>
                            <span v-if="export_filters.source.enabled && export_filters.source.prefix_map_id !== null" class="ml-2">
                                (Prefix Map ID: {{ export_filters.source.prefix_map_id }})
                            </span>
                             <span v-else-if="export_filters.source.enabled" class="ml-2 text-disabled">
                                (No Prefix Map ID)
                            </span>
                        </div>

                        <div class="mt-1">
                            <strong>Destination:</strong>
                             <v-chip
                                :color="export_filters.destination.enabled ? 'success' : 'grey'"
                                class="ml-2"
                                label
                                small
                            >
                                {{ export_filters.destination.enabled ? 'Enabled' : 'Disabled' }}
                            </v-chip>
                            <span v-if="export_filters.destination.enabled && export_filters.destination.prefix_map_id !== null" class="ml-2">
                                (Prefix Map ID: {{ export_filters.destination.prefix_map_id }})
                            </span>
                            <span v-else-if="export_filters.destination.enabled" class="ml-2 text-disabled">
                                (No Prefix Map ID)
                            </span>
                        </div>
                    </div>
                </v-col>
            </v-row>
             <v-row v-else>
                 <v-col>Loading settings...</v-col>
             </v-row>
        </v-card-text>
    </v-card>

    <v-data-table
        :headers="collector_headers"
        :items="collectors"
        :search="search"
        item-value="id"
        class="elevation-1"
    >

        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title><h2 class="br">NEL Collectors</h2></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog_add" max-width="600px" persistent>
                    <template v-slot:activator="{ props }">
                        <v-btn
                            color="primary"
                            dark
                            class="mb-2 action-btn-spacing"
                            v-bind="props"
                            :disabled="loading_data"
                            @click="open_add_dialog"
                        >
                            Add Collector
                        </v-btn>
                    </template>
                    <ValidationObserver ref="observer_add" v-slot="{ invalid }">
                        <v-card>
                            <v-form @submit.prevent="save_collector">
                                <v-card-title>
                                    <span class="headline">{{ add_form_title }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container style="max-height: 520px; overflow-y: scroll;">
                                        <v-row><v-col cols="12">
                                            <div class="form_text_field">
                                            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                                <v-text-field
                                                    v-model="edited_collector.ipv4_address"
                                                    label="IPv4 Address (*)"
                                                    hint="Collector's IPv4 address"
                                                    persistent-hint
                                                    required

                                                ></v-text-field>
                                                <span class="required_err">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            </div>

                                            <div class="form_text_field">
                                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                                <v-text-field
                                                    v-model.number="edited_collector.port_number"
                                                    label="Port (*)"
                                                    type="number"
                                                    hint="Default: 4739"
                                                    persistent-hint
                                                    required

                                                ></v-text-field>
                                                <span class="required_err">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            </div>

                                            <div class="form_select_field">
                                            <ValidationProvider rules="required" v-slot="{ errors }">
                                                <v-select
                                                    v-model="edited_collector.proto_value"
                                                    :items="protocol_options"
                                                    item-title="text"
                                                    item-value="value"
                                                    label="Protocol (*)"
                                                    hint="Default: 9 (NetFlow V9)"
                                                    persistent-hint
                                                    required
                                                    dense

                                                    class="protocol-select"
                                                ></v-select>
                                                <span class="required_err">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            </div>

                                            <div class="form_select_field">
                                            <ValidationProvider rules="" v-slot="{ errors }">
                                                <v-select
                                                    v-model="edited_collector.events"
                                                    :items="event_type_options"
                                                    label="Events to Send (Optional)"
                                                    multiple
                                                    clearable
                                                    chips
                                                    small-chips
                                                    dense
                                                    hint="Leave empty to send all event types"
                                                    persistent-hint
                                                    class="events-select"
                                                ></v-select>
                                            </ValidationProvider>
                                            </div>
                                        </v-col></v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close_add_dialog">Cancel</v-btn>
                                    <v-btn color="blue darken-1" :disabled="invalid" text type="submit">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </ValidationObserver>
                </v-dialog>
            </v-toolbar>

            <v-toolbar flat>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search Collectors (by IP, Port, Protocol, Events)"
                    single-line
                    hide-details
                    dense
                    variant="underlined"
                    :disabled="loading_data"
                ></v-text-field>
            </v-toolbar>

        </template>

        <template v-slot:item.protocol="{ item }">
            {{ format_protocol(item.protocol) }}
        </template>

        <template v-slot:item.events_str="{ item }">
             {{ item.events_str || 'All' }}
        </template>

        <template v-slot:item.actions="{ item }">
             <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="delete_collector(item)"
                        :disabled="loading_data || deleting_collector === item.id"
                        color="error"
                        :loading="deleting_collector === item.id"
                        class="ml-2"
                    >
                        mdi-delete
                    </v-icon>
                </template>
                <span>Delete collector {{ item.ipv4_address }}:{{ item.port }} (Proto: {{ format_protocol(item.protocol) }})</span>
            </v-tooltip>
        </template>

        <template v-slot:no-data>
            <span v-if="loading_data">Loading data...</span>
            <span v-else-if="fetch_error">NEL collectors are unavailable.</span>
            <span v-else>No NEL collectors configured.</span>
        </template>
    </v-data-table>

</div>
</template>

<script>
import api_client from '../services/api.js';
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
    name: "nel",
    components: { ValidationProvider, ValidationObserver },
    data: () => ({
        // --- Data fetched from API ---
        nel_enabled: null, // Store global enable status
        export_filters: { // Store filter settings with defaults
             source: { enabled: false, prefix_map_id: null },
             destination: { enabled: false, prefix_map_id: null }
        },
        collectors: [], // Holds the list of NEL collectors fetched from API

        // --- Component State ---
        loading_data: false, // Single loading state for the API call
        fetch_error: '',
        saving_collector: false, // Specific state for add operation
        deleting_collector: null, // Store ID of collector being deleted
        search: '',

        // --- Add Dialog State ---
        dialog_add: false,
        edited_collector: {}, // Will be populated in open_add_dialog
        default_collector: {
            ipv4_address: '',
            port_number: 4739,
            proto_value: 9, // Default NetFlow V9
            events: [], // Default empty (send all)
        },

        // --- Table Headers ---
        collector_headers: [
            { text: 'IPv4 Address', value: 'ipv4_address', align: 'start' },
            { text: 'Port', value: 'port' },
            { text: 'Protocol', value: 'protocol' },
            { text: 'Events Sent', value: 'events_str', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false, align: 'end' },
        ],

        // --- Form Options ---
         protocol_options: [
            { text: '9 (NetFlow V9)', value: 9 },
            { text: '10 (IPFIX)', value: 10 },
            { text: '100 (syslog)', value: 100 },
        ],
        event_type_options: ['pb', 'nat_sess', 'others'],

    }),

    computed: {
        // Title for the Add dialog
        add_form_title() {
            return 'Add New NEL Collector';
        },
    },

    watch: {
        // Reset dialog state when closed
        dialog_add(val) {
            val || this.close_add_dialog();
        },
    },

    created() {
        this.fetch_data(); // Load all data on component creation
    },

    methods: {
        // --- Helper for processing collector data ---
        _process_collector(col_data, index = null) {
            // Expects an object like { address, port, protocol, event_types } or edited_collector
            const address = col_data.ipv4_address || col_data.address;
            const port = col_data.port_number || col_data.port;
            const protocol = col_data.proto_value || col_data.protocol;
            const events = col_data.events || col_data.event_types || []; // Ensure events is an array

            // Generate unique ID - use index if available for fetch, otherwise generate based on data for add
            const id_suffix = index !== null ? index : `${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
            const id = `${address}-${port}-${protocol}-${id_suffix}`;

            return {
                ipv4_address: address,
                port: port,
                protocol: protocol,
                events: events, // Store the raw events array
                id: id,
                // Generate display string for events
                events_str: Array.isArray(events) && events.length > 0 ? events.join(', ') : 'All'
            };
        },

        // --- Data Fetching & Processing ---
        async fetch_data() {
            this.loading_data = true;
            this.fetch_error = '';
            this.collectors = []; // Clear previous collectors
            this.nel_enabled = null; // Reset settings
            this.export_filters = { source: { enabled: false, prefix_map_id: null }, destination: { enabled: false, prefix_map_id: null }}; // Reset filters

            try {
                const response = await api_client.run_get_query('/nel/show');
                const data = response?.data;

                if (!data || typeof data !== 'object' || Array.isArray(data)) {
                    throw new Error("Invalid response structure from server.");
                }

                if (Object.prototype.hasOwnProperty.call(data, 'err_msg')) {
                    throw new Error(data.err_msg || 'BR command failed.');
                }

                if (typeof data.nel_enabled !== 'boolean' ||
                        !Array.isArray(data.collectors) ||
                        typeof data.export_filters?.source?.enabled !== 'boolean' ||
                        typeof data.export_filters?.destination?.enabled !== 'boolean') {
                    throw new Error("Invalid NEL settings from server.");
                }

                this.nel_enabled = data.nel_enabled;
                this.export_filters = {
                    source: { ...this.export_filters.source, ...data.export_filters.source },
                    destination: { ...this.export_filters.destination, ...data.export_filters.destination },
                };
                this.collectors = data.collectors.map((col, index) => this._process_collector(col, index));
            }
            catch (error) {
                console.error("Error fetching NEL data:", error);
                const detail = error.response?.data?.detail || error.message || 'Failed to query BR.';
                this.fetch_error = `NEL settings are unavailable. ${detail}`;
                // Ensure data is reset on error
                this.collectors = [];
                this.nel_enabled = null;
                this.export_filters = { 
                    source: { enabled: false, prefix_map_id: null }, 
                    destination: { enabled: false, prefix_map_id: null }
                };
            }
            finally {
                this.loading_data = false;
            }
        },

        // --- Dialog Management ---
        open_add_dialog() {
            this.edited_collector = { ...this.default_collector };
            this.dialog_add = true;
            // Reset validation state if observer is rendered
            this.$nextTick(() => {
                this.$refs.observer_add?.reset();
            });
        },

        close_add_dialog() {
            if (this.saving_collector) return; // Prevent closing while saving
            this.dialog_add = false;
            // No need to reset edited_collector here, open_add_dialog handles it
        },

        // --- CRUD Operations ---
        async save_collector() {
            this.saving_collector = true;
            // Payload uses keys expected by the '/api/nel/collector/add' endpoint
            const payload = {
                ipv4_address: this.edited_collector.ipv4_address,
                port_number: this.edited_collector.port_number,
                proto_value: this.edited_collector.proto_value,
                // Send events only if the array is not empty, key is 'events'
                ...(this.edited_collector.events && this.edited_collector.events.length > 0 && { events: this.edited_collector.events })
            };

            try {
                const response = await api_client.run_post_query('/nel/collector/add', payload);

                if (response.data && response.data.hasOwnProperty("err_msg")) {
                    this.$fire({ title: "Failed to Add Collector", text: response.data.err_msg, type: "warning" });
                    this.saving_collector = false; // Reset saving state on failure
                    return; // Stay in dialog
                }

                // Success: Add the new collector locally
                const new_collector = this._process_collector(this.edited_collector);
                this.collectors.push(new_collector);

                this.saving_collector = false;
                this.close_add_dialog();
            } 
            catch (error) {
                console.error("Error adding NEL collector:", error);
                this.$fire({title: "Error Adding Collector", text: error, type: "error"});
            } 
        },

        delete_collector(item) {
            // Use the internally mapped/stored keys for the confirmation message
            const msg = `Are you sure you want to delete the NEL collector at ${item.ipv4_address}:${item.port} (Protocol: ${this.format_protocol(item.protocol)})?`;
            this.$confirm(msg)
                .then((res) => {
                    if (res) {
                        this.delete_collector_confirm(item);
                    }
                });
        },

        async delete_collector_confirm(item_to_delete) {
            this.deleting_collector = item_to_delete.id; // Set loading state for this specific item

            // Payload uses keys expected by the '/api/nel/collector/delete' endpoint
            // We get these values from the 'item_to_delete' which has the processed data
            const payload = {
                ipv4_address: item_to_delete.ipv4_address, // Use the mapped address
                port_number: item_to_delete.port, // Use the port from the item
                proto_value: item_to_delete.protocol // Use the protocol from the item
            };

            try {
                const response = await api_client.run_post_query('/nel/collector/delete', payload);

                if (response.data && response.data.hasOwnProperty("err_msg")) {
                    this.$fire({ title: "Failed to Delete Collector", text: response.data.err_msg, type: "warning" });
                    return;
                }

                // Success: Remove the collector locally
                const index_to_delete = this.collectors.findIndex(col => col.id === item_to_delete.id);
                if (index_to_delete > -1) {
                    this.collectors.splice(index_to_delete, 1);
                }
                else {
                    console.warn("Could not find collector to delete locally, ID:", item_to_delete.id);
                    await this.fetch_data();
                }
            }
            catch (error) {
                console.error("Error deleting NEL collector:", error);
                this.$fire({title: "Error Deleting Collector", text: error, type: "error"});
            } 
            finally {
                this.deleting_collector = null; // Reset loading state
            }
        },

        // --- Formatting & Helpers ---
        format_protocol(proto_value) {
            const option = this.protocol_options.find(opt => opt.value === proto_value);
            return option ? option.text : String(proto_value); // Fallback to raw value
        },
    }
};
</script>
